
import _padStart from "lodash/padStart"
import { gateNonstandardDateToDate } from "../../../sg-core";
import _format from "date-fns/format";
import IObservation, { EObservationStatus, EProcessingMarkingPublicity } from "../interfaces/IObservation";
import { getRouteHrefById } from "../../../routing";
import { HavainnotRouteId } from "../../routes";
import { LocationDescriptorObject } from "history";
import IFormDefinition from "../interfaces/IFormDefinition";
import IFormType from "../interfaces/IFormType";
import { IFormSchema } from "@/@auditoinnit/auditoinnit/interfaces/IFormSchema";

/**
 * Creates readable version of entity id
 * @param id 
 */
export const formatIdLabel = (id: number): string => {
    return "#" + _padStart(("" + id), 2, "0");
}


export const validateProcessingSchema = (formSchema: IFormSchema): boolean => {
    const properties = formSchema.schema.properties || {};


    // Check is public property
    if (properties.on_julkinen) {
        if (!(properties.on_julkinen instanceof Object)) {
            return false
        };
        if (properties.on_julkinen.type !== "boolean") {
            console.warn("[validateProcessingSchema]: found invalid type for on_julkinen, should be 'boolean' ")
            return false;
        };
    };

    // Check processing marking publicity property
    if (properties.kasittelymerkintojen_julkisuus) {
        if (!(properties.kasittelymerkintojen_julkisuus instanceof Object)) {
            return false
        };
        const enumOptions = properties.kasittelymerkintojen_julkisuus.enum || [];
        const knownEnums = Object.values(EProcessingMarkingPublicity);
        const uknwownEnums = enumOptions.find((opt) => !knownEnums.includes(opt as any));
        if (uknwownEnums && enumOptions) {
            console.warn("[validateProcessingSchema]: found uknown enum for kasittelymerkintojen_julkisuus '" + uknwownEnums + "'")
            return false
        };
    };

    // Check status property
    if (properties.tila) {
        if (!(properties.tila instanceof Object)) {
            return false
        };
        const enumOptions = properties.tila.enum || [];
        const knownEnums = Object.values(EObservationStatus);
        const uknwownEnums = enumOptions.find((opt) => !knownEnums.includes(opt as any));
        if (enumOptions && uknwownEnums) {
            console.warn("[validateProcessingSchema]: found uknown enum for tila '" + uknwownEnums + "'")
            return false
        };
    };


    return true
}

export const getReadableTimestamp = (rawTimestamp: Date | null | string): string => {
    let timestamp = rawTimestamp;

    if (typeof rawTimestamp === "string") {
        timestamp = gateNonstandardDateToDate(rawTimestamp)
    }

    return timestamp ? _format(timestamp as Date, "dd.MM.yyyy HH:mm") : ""
}



export const getLatestProcessingMarking = (observation: IObservation) => {
    const markings = observation.formData.merkinnat;

    const latestToOldest = markings?.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    const latestMarking = latestToOldest ? latestToOldest[0] : undefined
    return latestMarking
}

export const getProcessingMarkingPublicityStatus = (observation: IObservation) => {
    const markings = observation.formData.merkinnat;

    const latestToOldest = markings?.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    const latestMarking = latestToOldest ? latestToOldest[0] : undefined
    return latestMarking?.formData.kasittelymerkintojen_julkisuus;
};


export const makeAnonObservationHref = (packageId: any, printLanguage: any): string => {
    const baseUrl = window.location.origin;
    return `${baseUrl}${process.env.publicUrl || ""}${getRouteHrefById(HavainnotRouteId.AnonymousObservation, { package: packageId })}?lang=${printLanguage}`
};




export const makeNewObservationPageHref = (formDefinition: IFormDefinition["id"], formType: IFormType["guid"]): LocationDescriptorObject => {
    return {
        pathname: getRouteHrefById(HavainnotRouteId.NewObservationPage, { formDefinition, formType }),
        state: { clearStorage: true }
    }
};
